Customer.Dashboard ||= {}

class Customer.Dashboard.TicketSalesforceButtonView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/detail/box/ticket_salesforce_button']

  events:
    'click #create-crm-case': 'onClickCreateCrmCase'
    'click #save': 'onClickSave'

  initialize: (@options) ->
    @ticket = @options.ticket
    @contactsSearchResult = undefined
    @setElement('<span></span>')
    @listenTo(@ticket.get('integrations'), 'ticket:searchcontacts:success', @onSearchContactsSuccess)
    @delegateEvents(@events)

  render: ->
    @$el.html(@template(ticket: @ticket.get('integrations').get('salesforce'), contacts_search_result: @contactsSearchResult))
    @delegateEvents(@events)
    @

  onClickCreateCrmCase: =>
    @trigger('onClickCreateCrmCase', 'salesforce')

  onSearchContactsSuccess: (contacts_search_result) =>
    console.log(contacts_search_result)
    @contactsSearchResult = contacts_search_result
    @render()
    @$el.find('#contact-selection').modal()

  onClickSave: =>
    contactId = @$el.find("input[name='contact']:checked").val()
    @$el.find('#contact-selection').modal('hide')
    @trigger('onSelectContact', contactId)
